// NGN header lockup: "NGN logo | <app icon> App name" (ngn/brand#8).
// Generated by scripts/build-appmarks.py from apps/apps.json; do not edit.
// Needs apps/lockup/ngn-lockup.css loaded once, and the files under `base`:
// logo-light.png, logo-dark.png and apps/<app>/icon.svg. No dependencies.
import type { CSSProperties, ReactElement } from "react";

export const NGN_APPS = {
  billing: "Billing",
  hosting: "Hosting",
  mail: "Mail",
  seo: "SEO",
  integration: "Integration",
  helpdesk: "Helpdesk",
  mdm: "MDM",
  monitoring: "Monitoring",
  phone: "Phone",
  docs: "Docs",
  signin: "Sign-in",
} as const;

export type NgnApp = keyof typeof NGN_APPS;

export interface NgnLockupProps {
  /** The app: picks the icon and the default name. */
  app: NgnApp;
  /** Override the shown name (keep it a generic function, never a product). */
  name?: string;
  /** Where the lockup links to. Default "/". */
  href?: string;
  /** Where the brand files are served. Default "/brand". */
  base?: string;
  /** Force a theme (for apps with their own colour-scheme state); default follows the system. */
  theme?: "light" | "dark";
  /** Height in px; default the brand's header logo height. */
  height?: number;
  className?: string;
}

export function NgnLockup({ app, name, href = "/", base = "/brand", theme, height, className }: NgnLockupProps): ReactElement {
  const style = height ? ({ "--ngn-lockup-height": `${height}px` } as CSSProperties) : undefined;
  return (
    <a className={className ? `ngn-lockup ${className}` : "ngn-lockup"} href={href} data-theme={theme} style={style}>
      <img className="ngn-lockup-logo ngn-lockup-logo-light" src={`${base}/logo-light.png`} alt="NGN" />
      <img className="ngn-lockup-logo ngn-lockup-logo-dark" src={`${base}/logo-dark.png`} alt="NGN" />
      <span className="ngn-lockup-rule" aria-hidden="true" />
      <img className="ngn-lockup-icon" src={`${base}/apps/${app}/icon.svg`} alt="" />
      <span className="ngn-lockup-name">{name ?? NGN_APPS[app]}</span>
    </a>
  );
}

export default NgnLockup;
